"use strict";
var vidi_1 = require("./vidi");
exports.Vidi = vidi_1.Vidi;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = vidi_1.Vidi;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/index.js
// module id = 592
// module chunks = 0 1 2 3